'use es6';

import tinymce from 'tinymce';
import { addPreProcessTransform, addPostProcessTransform } from '../utils/transformer';
import { HS_ESCAPE_NEWLINES } from '../constants/plugins';
function plugin(editor) {
  addPreProcessTransform(editor, dom => {
    const body = dom.querySelectorAll('body');
    if (body.length === 1) {
      const swappedNewlines = body[0].innerHTML.replace(/(?:\r\n|\r|\n)/g, '<br>');
      editor.dom.replace(editor.dom.create('body', {}, swappedNewlines), body[0]);
    }
  });
  addPostProcessTransform(editor, dom => {
    Array.from(dom.querySelectorAll('p')).forEach(node => {
      // don't need to replace with \n, tinymce already adds them between block elements in the output
      editor.dom.replace(editor.dom.createFragment(node.innerHTML), node);
    });
    Array.from(dom.querySelectorAll('br')).forEach(node => {
      editor.dom.replace(editor.dom.createFragment('\n'), node);
    });
  });
}
tinymce.PluginManager.add(HS_ESCAPE_NEWLINES, plugin);